import { defineStore } from "pinia";
import { ref } from "vue";

export const useNotificationStore = defineStore("notifications", () => {
  const toasts = ref([]);
  const nextId = ref(1);

  function showToast(type, message, description = "", duration = 5000) {
    const id = nextId.value++;
    const toast = {
      id,
      type,
      message,
      description,
      duration,
      isConfirm: false,
      createdAt: Date.now(),
    };

    toasts.value.push(toast);
    return id;
  }

  function showConfirm(
    message,
    onConfirm,
    onCancel = null,
    description = "",
    confirmLabel = "Confirm",
    duration = null
  ) {
    const id = nextId.value++;
    const toast = {
      id,
      type: "confirm",
      message,
      description,
      duration,
      isConfirm: true,
      confirmLabel,
      onConfirm,
      onCancel,
      createdAt: Date.now(),
    };

    toasts.value.push(toast);
    return id;
  }

  function removeToast(id) {
    const index = toasts.value.findIndex((t) => t.id === id);
    if (index !== -1) {
      toasts.value.splice(index, 1);
    }
  }

  function clearAll() {
    toasts.value = [];
  }

  function success(message, description = "", duration = 5000) {
    return showToast("success", message, description, duration);
  }

  function error(message, description = "", duration = 5000) {
    return showToast("error", message, description, duration);
  }

  function warning(message, description = "", duration = 5000) {
    return showToast("warning", message, description, duration);
  }

  function info(message, description = "", duration = 5000) {
    return showToast("info", message, description, duration);
  }

  return {
    toasts,
    showToast,
    showConfirm,
    removeToast,
    clearAll,
    success,
    error,
    warning,
    info,
  };
});
